import styled from "styled-components"
import { MaterialIcon } from "./MaterialIcon";

export const ModeuleNotAvailable = () => {

    return (
        <StyledModeuleNotAvailable>
            <div className="icon">
                <MaterialIcon
                    name='shield_lock'
                    weight={300}
                    size='xxl'
                    color={({theme}) => theme.colors.errorForeground}
                />
            </div>
            <div className="moduleNotAvailableTitle">
                Modul ikke tilgjengelig
            </div>
            <div className="moduleNotAvailableText">
                Modul er ikke tilgjengelig for øyeblikk.
            </div>
        </StyledModeuleNotAvailable>
    )
}

const StyledModeuleNotAvailable = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    div.icon
    {
        background: ${({theme}) => theme.colors.errorBackground};
        padding: ${({theme}) => theme.spacing.md};
        border-radius: ${({theme}) => theme.cornerRadius.lg};
        margin-bottom: ${({theme}) => theme.spacing.lg};
        filter: drop-shadow(0 2px 2px rgba( ${({theme}) => theme.colors.neutralSecondaryForegroundRGB}, 0.15));
        display: flex;
        align-items: center;
        justify-content: center;
    }

    div.moduleNotAvailableTitle
    {
        font-weight: 500;
        font-size: ${({theme}) => theme.fontSize.xl};
        color: ${({theme}) => theme.colors.mutedForeground};
        margin-bottom: ${({theme}) => theme.spacing.md};
    }

    div.moduleNotAvailableText
    {
        font-weight: 500;
        font-size: ${({theme}) => theme.fontSize.md};
        color: ${({theme}) => theme.colors.mutedForeground};
    }
`